import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as H, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as u } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, A = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconPath"
}, b = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: h, weight: l } = m(s);
    return (d, a) => (t(), o("svg", H({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(h)), [
      i(d.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", g, a[0] || (a[0] = [
        n("path", { d: "M200,164a36.07,36.07,0,0,0-33.94,24H72a28,28,0,0,1,0-56h96a44,44,0,0,0,0-88H72a12,12,0,0,0,0,24h96a20,20,0,0,1,0,40H72a52,52,0,0,0,0,104h94.06A36,36,0,1,0,200,164Zm0,48a12,12,0,1,1,12-12A12,12,0,0,1,200,212Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", Z, a[1] || (a[1] = [
        n("path", {
          d: "M224,200a24,24,0,1,1-24-24A24,24,0,0,1,224,200Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", f, a[2] || (a[2] = [
        n("path", { d: "M228,200a28,28,0,0,1-54.83,8H72a48,48,0,0,1,0-96h96a24,24,0,0,0,0-48H72a8,8,0,0,1,0-16h96a40,40,0,0,1,0,80H72a32,32,0,0,0,0,64H173.17A28,28,0,0,1,228,200Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", A, a[3] || (a[3] = [
        n("path", { d: "M200,170a30.05,30.05,0,0,0-29.4,24H72a34,34,0,0,1,0-68h96a38,38,0,0,0,0-76H72a6,6,0,0,0,0,12h96a26,26,0,0,1,0,52H72a46,46,0,0,0,0,92h98.6A30,30,0,1,0,200,170Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,200,218Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", k, a[4] || (a[4] = [
        n("path", { d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", w, a[5] || (a[5] = [
        n("path", { d: "M200,172a28,28,0,0,0-27.71,24H72a36,36,0,0,1,0-72h96a36,36,0,0,0,0-72H72a4,4,0,0,0,0,8h96a28,28,0,0,1,0,56H72a44,44,0,0,0,0,88H172.29A28,28,0,1,0,200,172Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,200,220Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  b as default
};
